import {createApp} from "vue";
import {mapActions, mapGetters} from "vuex";
import store from './store'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import lodash from 'lodash'
import Toast from "vue-toastification";
import inputMaskDirective from "@/directives/mask";

import 'vue-toastification/dist/index.css';
import '@vueform/multiselect/themes/default.css';

import ProductListStock from "@/components/catalog/ProductListStock.vue";
import ProductListSolutions from "@/components/catalog/ProductListSolutions.vue";
import ProductCard from "@/components/catalog/ProductCard.vue";
import ProductCardSolutions from "@/components/catalog/ProductCardSolutions.vue";
import WebFormFeedback from "@/components/webform/WebFormFeedback.vue";
import WebFormFeedbackEn from "@/components/webform/WebFormFeedbackEn.vue";
import WebFormVacancy from "@/components/webform/WebFormVacancy.vue";
import WebFormCompany from "@/components/webform/WebFormCompany.vue";
import AddToCart from "@/components/cart/AddToCart.vue";
import CartSmall from "@/components/cart/CartSmall.vue";
import CartBig from "@/components/cart/CartBig.vue";
import CartCheckout from "@/components/cart/CartCheckout.vue";
import IndividualPacking from "@/components/individual-packing/IPMain.vue";
import CatalogFilter from "@/components/catalog/CatalogFilter";
import AddToCartDetail from "@/components/cart/AddToCartDetail.vue";
import SearchHeader from "@/components/search/SearchHeader.vue";

const APP_OPTIONS = {
    components: {
        AddToCartDetail, ProductListStock, ProductListSolutions, ProductCard, ProductCardSolutions, WebFormFeedback, WebFormFeedbackEn, WebFormVacancy, WebFormCompany, AddToCart, CartSmall, CartCheckout, IndividualPacking, CartBig, CatalogFilter, SearchHeader
    },
    data() {
        return {
            loadingRequests: [],
            initData: {
                user: {}
            },

        }
    },
    created() {
        this.loadCart();
    },
    computed: {
        ...mapGetters('moduleCart', {
            cntCartItems: 'cntItems'
        }),
        isCartFilled: function(){
            return this.cntCartItems > 0
        },
    },
    methods: {
        ...mapActions({
            loadCart: 'moduleCart/load',
        })
    }

}

const app = createApp(APP_OPTIONS);

app.config.productionTip = false;
app.config.devtools = false;
app.config.debug = false;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$lodash = lodash;

app.use(store).use(VueCookies).use(Toast);
app.directive("mask", inputMaskDirective);

document.addEventListener('DOMContentLoaded', () => {
    app.mount('#app');
});